var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-watch"},[_c('video',{staticClass:"video mx-auto d-block",attrs:{"id":"liveWatch","autoplay":"","controls":""}}),_c('video-controls',{on:{"setVideoQulity":_vm.onSetVideoQulity}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }